const parseJSONWithDefault = (jsonString, defaultValue) => {
  try {
    if (!jsonString) {
      throw new Error("Invalid input");
    }
    return JSON.parse(jsonString);
  } catch (error) {
    return defaultValue;
  }
};
function randomChance(probability) {
  if (probability < 0 || probability > 1) {
    return false;
  }
  const randomValue = Math.random();
  return randomValue < probability;
}
export {
  parseJSONWithDefault,
  randomChance
};
